/**
 * JSON.stringify with deterministically sorted object keys, so logically
 * identical payloads always produce the same key regardless of the key order
 * the server happened to emit. Used to dedupe interrupts, which carry no id.
 * @param value - The value to serialise canonically.
 * @returns A deterministic string representation of the value.
 */
export const stableStringify = (value: unknown): string => {
  if (Array.isArray(value)) {
    return `[${value.map(stableStringify).join(",")}]`;
  }
  if (value !== null && typeof value === "object") {
    const entries = Object.entries(value)
      .filter(([, entryValue]) => entryValue !== undefined)
      .sort(([key1], [key2]) => key1.localeCompare(key2))
      .map(
        ([key, entryValue]) =>
          `${JSON.stringify(key)}:${stableStringify(entryValue)}`
      );
    return `{${entries.join(",")}}`;
  }
  return JSON.stringify(value) ?? "undefined";
};
